import { ReactElement } from 'react';

import { LISTING_FUNCTIONS } from '@/common/analytics/gtm/types';
import { Feed } from '@/common/components/MasonryFeed/MasonryFeeds';
import { NextLinkAllPosters } from '@/common/components/MasonryFeed/MasonryFeeds.styled';
import { createFeedFactory } from '@/common/components/MasonryFeed/MasonryFeedsUtils';
import { ComponentMetadata } from '@/common/components/types';
import { FOLLOWING_FEED_NAME } from '@/modules/Following/constants';
import FollowingEmptyState from '@/modules/Following/FollowingEmptyState';
import { RouteToFollowingPage } from '@/modules/Following/FollowingPageConfig';
import { HomepageConfig } from '@/modules/HomePage/HomePageConfig';
import { HomepageFeedsV2, UserInfoV2 } from 'generatedBfw/static';

const followingRedirectButton = (): ReactElement => (
  <NextLinkAllPosters href={RouteToFollowingPage().route}>See all following</NextLinkAllPosters>
);

export const createMasonryHpFeeds = (
  hpFeeds: HomepageFeedsV2 | undefined,
  userInfo: UserInfoV2 | null,
  areFeedsUpToDate: boolean,
): Feed[] => {
  if (!areFeedsUpToDate) return [];
  const createFeed = createFeedFactory<HomepageFeedsV2>(hpFeeds);
  const isUserLoggedIn = !!userInfo?.isUserLoggedIn;
  const followingFeedItems = isUserLoggedIn && hpFeeds?.following ? hpFeeds.following : [];

  return [
    createFeed('personalised', LISTING_FUNCTIONS.PERSONALIZED, { name: 'for you' }),
    createFeed('trending', LISTING_FUNCTIONS.TRENDING),
    createFeed('following', LISTING_FUNCTIONS.FOLLOW, {
      name: FOLLOWING_FEED_NAME,
      items: followingFeedItems,
      overrideGridComponent: followingFeedItems.length === 0 ? FollowingEmptyState : undefined,
      shouldBeShown: hpFeeds !== undefined,
      redirectButton: followingRedirectButton,
    }),
    createFeed('bestselling', LISTING_FUNCTIONS.BESTSELLING),
  ];
};

export const createFeedsTitle = (firstName?: string): string => {
  return `${firstName ? firstName + ', ' : ''}see the hottest picks`;
};

export const masonryHpMetadata: ComponentMetadata = {
  itemListName: 'Popular',
  listingFunction: LISTING_FUNCTIONS.POPULAR,
  listingType: 'masonry',
  athenaPageName: HomepageConfig.analyticsAthenaName,
  gaPageName: HomepageConfig.analyticsGaName,
};
